<template>
  <div 
    v-if="hasRequiredData" 
    class="Layout Layout--default">

    <NavBar class="Layout__navbar" />
    <SideBar class="Layout__sidebar" :menu-items="menuItems" />

    <div class="Layout__content p-5">
      <slot />
    </div>
  </div>
  <div 
    v-else 
    class="d-flex flex-column justify-content-center align-items-center">
    Loading data, please wait...
  </div>
</template>

<script>
import SideBar from 'organism/SideBar';
import NavBar from 'organism/NavBar';

import MenuItem from 'model/MenuItem';

import { getUser } from 'service/auth'
import { mapGetters, mapMutations } from 'vuex';

/**
 * The layout for the general user pages.
 */
export default {
  components: {
    SideBar, NavBar
  },
  data() {
    return {
      hasRequiredData: true,
      menuItems: [
        new MenuItem({
          label: 'Prognose Kaart',
          icon: 'map-light.svg',
          to: { name: 'home' }
        }),
        new MenuItem({
          label: 'Aanvragen',
          icon: 'file-alt-light.svg',
          to: { name: 'reports' }
        }),
        new MenuItem({
          label: 'Log uit',
          icon: 'sign-out-light.svg',
          to: { name: 'logout' }
        })
      ]
    }
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },
  async created() {
    // Check login
    // this.$router.push({ name: 'login' })
    if (!this.user) {
      this.setUser({ authenticatedUser: getUser() })
    }
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
  }
}
</script>

<style lang="scss">
.Layout {
  display: grid;
  grid-template-columns: 265px calc(100% - 265px);
  grid-template-rows: 70px calc(100% - 70px);
  gap: 0px 0px;
  grid-template-areas:
    "Header Header"
    "Sidebar Content";

  max-height: 100vh;
  max-width: 100vw;

  &--default {
    .Layout__content {
      overflow-y: scroll;
    }
  }

}
.Layout__navbar {
  grid-area: Header;
}
.Layout__sidebar {
  grid-area: Sidebar;
}
.Layout__content {
  grid-area: Content;
  position: relative;
}

@media all and (-ms-high-contrast:none) {

  .Layout {
    display: -ms-grid;
    -ms-grid-columns: 265px 1fr;
    -ms-grid-rows: 70px 1fr;
    gap: 0px 0px;
  }

  .Layout__navbar {
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
  }

  .Layout__sidebar {
    -ms-grid-row: 2;
    -ms-grid-row-span: 1;
    -ms-grid-column: 1;
    -ms-grid-column-span: 0;
  }

  .Layout__content {
    -ms-grid-row: 2;
    -ms-grid-row-span: 1;
    -ms-grid-column: 2;
    -ms-grid-column-span: 1;
  }

}
</style>
